const carouselItems = [
  {
    title: '国产高清视频周榜',
    desc: '本周最受关注的91国产高清视频TOP精选，涵盖多元题材与风格，点击即刻观看热门佳作。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20abstract%20poster%20design%20with%20warm%20coral%20and%20deep%20crimson%20gradients%2C%20stylized%20ranking%20numbers%20and%20film%20elements%2C%20glowing%20geometric%20accents%2C%20dark%20premium%20background%2C%20luxurious%20theater%20marquee%20vibe%2C%20modern%20editorial%20content%20banner%20style&width=700&height=450&seq=carousel-91md-01&orientation=landscape',
    tag: '周榜精选',
  },
  {
    title: '超清画质影视专题',
    desc: '精选1080P超清视频在线观看合集，从画质到音效全面升级，带来沉浸式影院级观影享受。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20cinema%20themed%20visual%20with%20crystal%20clear%20diamond%20geometric%20shapes%2C%20warm%20golden%20and%20amber%20light%20reflections%2C%20premium%20theater%20curtain%20motif%20in%20abstract%20form%2C%20dark%20sophisticated%20atmosphere%2C%20high%20end%20entertainment%20branding%20aesthetic&width=700&height=450&seq=carousel-91md-02&orientation=landscape',
    tag: '超清专题',
  },
  {
    title: '每日上新热门推荐',
    desc: '今日最新上线的91高清视频在线内容速递，编辑精选每日不可错过的精彩视频合集。',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20abstract%20visual%20representing%20fresh%20daily%20content%2C%20warm%20sunrise%20gradients%20in%20coral%20and%20orange%20tones%2C%20flowing%20ribbon%20shapes%20suggesting%20continuous%20updates%2C%20dark%20modern%20background%20with%20subtle%20sparkle%20effects%2C%20vibrant%20editorial%20design%20style&width=700&height=450&seq=carousel-91md-03&orientation=landscape',
    tag: '今日上新',
  },
  {
    title: '流畅播放技术解析',
    desc: '深入了解91麻豆免费视频网站背后的流媒体加速技术，自适应码率与智能预加载如何保障流畅体验。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20tech%20visual%20with%20smooth%20flowing%20data%20streams%2C%20warm%20copper%20and%20bronze%20network%20node%20patterns%2C%20interconnected%20geometric%20shapes%20with%20soft%20glow%2C%20dark%20futuristic%20background%2C%20modern%20technology%20infographic%20aesthetic&width=700&height=450&seq=carousel-91md-04&orientation=landscape',
    tag: '技术解析',
  },
  {
    title: '海量资源分类导航',
    desc: '超过20000部精选资源的全分类导览，快速定位您感兴趣的91国产高清视频与高清影视在线内容。',
    img: 'https://readdy.ai/api/search-image?query=Organized%20abstract%20grid%20layout%20representing%20content%20categories%2C%20warm%20terracotta%20and%20sienna%20color%20blocks%20with%20soft%20borders%2C%20structured%20geometric%20pattern%2C%20dark%20elegant%20foundation%2C%20modern%20directory%20interface%20design%20concept&width=700&height=450&seq=carousel-91md-05&orientation=landscape',
    tag: '分类导航',
  },
  {
    title: '移动端观影指南',
    desc: '手机观看91高清视频在线的完整指南，从浏览器设置到播放优化，让移动观影体验达到最佳状态。',
    img: 'https://readdy.ai/api/search-image?query=Mobile%20device%20themed%20abstract%20visual%20with%20phone%20silhouette%20and%20media%20elements%2C%20warm%20rose%20gold%20and%20coral%20gradients%2C%20stylized%20touch%20interface%20patterns%2C%20dark%20premium%20background%2C%20modern%20mobile%20lifestyle%20editorial%20aesthetic&width=700&height=450&seq=carousel-91md-06&orientation=landscape',
    tag: '移动指南',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            焦点专题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            六大深度专题栏目，从内容到技术全方位解读平台特色
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {carouselItems.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-accent-500 text-white text-xs font-medium rounded-md whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-heading font-semibold text-foreground-950 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}